"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWaitForCondition = exports.waitForCondition = void 0;
var waitForCondition_1 = require("./waitForCondition");
Object.defineProperty(exports, "waitForCondition", { enumerable: true, get: function () { return waitForCondition_1.waitForCondition; } });
Object.defineProperty(exports, "createWaitForCondition", { enumerable: true, get: function () { return waitForCondition_1.createWaitForCondition; } });
//# sourceMappingURL=index.js.map